import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import LTTPodcastNavbarmenu from "../PodCastFolder/LTTPodcastNavbarmenu";
import PodcastSideNavbar from "../PodCastFolder/PodcastSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import "./FAQsContent.css";
import { FaqData } from "./FAQsData";

function FAQsContent() {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const toggleContent = (id) => {
    setExpandedId((prevId) => (prevId === id ? null : id));
  };

  const renderHTMLContent = (Answer, isExpanded) => {
    const html = isExpanded
      ? Answer
      : Answer.length > 230
      ? Answer.slice(0, 230) + "..."
      : Answer;

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };

  return (
    <>
      <div className="navbar-holder podcast-navbar-holder">
        <LTTPodcastNavbarmenu />
      </div>
      <div className="podcast-sidenavbar-holder">
        <PodcastSideNavbar />
      </div>
      <div className="video-container" id="main">
        <title>L-TT Podcast FAQs</title>
        {/* <h1 class="sr-only" tabIndex={0}>
          FAQs
        </h1> */}
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/faq-banner-mobile.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={process.env.PUBLIC_URL + "/images/Banners/faq-banner.png"}
          alt="faq-banner"
          className="banner-img desktop-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              className="breadcrumbs-links"
              activeClassName="is-active"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              className="breadcrumbs-links"
              activeClassName="is-active"
              to="/LTT-Podcast"
            >
              L&TT Podcast
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              className="breadcrumbs-links"
              activeClassName="is-active"
              to="/FAQs"
            >
              FAQs
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box">
          <h1 tabIndex={0}>How Can We Help You?</h1>
          <p>
            Find helpful answers to common queries to make your podcasting
            journey easier.
          </p>
        </div>
        {/* <p>
          Find helpful answers to common queries to make your podcasting journey
          easier.
        </p> */}
      </div>
      <div className="faqs-container">
        <div className="faqs-wrap">
          <h2 className="main-headings faq">Frequently Asked Questions</h2>
          <div className="faqs-extra-row">
            {FaqData.map((item) => {
              const isExpanded = expandedId === item.id;
              const hasLongContent = item.Answer && item.Answer.length > 230;

              return (
                <div key={item.id} className="faqs-row" data-aos="zoom-in-up">
                  <div className="faqs-box">
                    <div className="faqs-content-box box1">
                      <h2>{item.id}</h2>
                    </div>
                    <div className="faqs-content-box box2">
                      <h3>{item.Question}</h3>
                    </div>
                    <div className="faqs-content-box box3">
                      <div
                        className={`faq-answer-content ${
                          !isExpanded ? "faq-answer-collapsed" : ""
                        }`}
                        style={{ display: "inline" }}
                      >
                        {renderHTMLContent(item.Answer, isExpanded)}
                      </div>
                      {hasLongContent && (
                        <button
                          onClick={() => toggleContent(item.id)}
                          className="view-more-btn"
                          style={{ display: "inline", marginLeft: "6px" }}
                        >
                          {isExpanded ? "See less" : "View more"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQsContent;
